<template>
  <div>
    <!-- <x-org-heading heading="Billing"> </x-org-heading> -->

    <x-table
      :columns="columns"
      :loading="loading"
      :tableRows="rowsData"
      :sortBy="sortBy"
      :updateTableSize="updatePageSize"
      :paginationData="{
        pageSize: pageSize,
        pageNumber,
        totalRecords,
        setPage
      }"
      :data-test-id="`${dataTestId}`"
    >
      <template slot="table-top-right"></template>
      <template slot="table_item" slot-scope="props">
        <tr v-for="bill in props.tableRows" :key="bill.id">
          <td>{{ bill.id }}</td>
          <!-- <td>{{ bill.subscriptionId }}</td> -->
          <td id="transaction__id">{{ bill.transactionType }}</td>
          <td>{{ bill.memo }}</td>
          <td>
            <!-- {{
            numberINString(bill.amountInCents / 100, 'en-GB', {
            style: 'currency',
            currency: currency,
            })
            }} -->
            <!-- {{currency}}{{' '}}{{bill.amountInCents / 100}} -->
            {{ (currency + bill.amountInCents / 100) | getFormatedAmount }}
          </td>
          <td>{{ getFormatedDateAsPerTimeAndDate(bill.createdAt) }}</td>

          <td>
            <span class="text-success" v-if="bill.success === 'true'"
              >Successful</span
            >
            <span class="text-error" v-if="bill.success === 'false'"
              >Failure</span
            >
          </td>
        </tr>
      </template>
    </x-table>
  </div>
</template>
<script>
import BillingService from '../../../services/BillingService';
import { getTableColumns } from '../../../helpers/TableHelpers';
import { numberINString } from '../../../helpers/common';
import axios from 'axios';
export default {
  data() {
    return {
      columns: this.copyArray(getTableColumns('payments')),
      numberINString,
      loading: true,
      sortOrder: 'DESC',
      pageSize: 20,
      pageNumber: 1,
      totalRecords: 0,
      rowsData: [],
      // Generating cancelation token
      axiosSource: axios.CancelToken.source(),
      errorMessage:
        'Landing Component got unmounted before network call completed',
      dataTestId: 'configuration__billing-plans__transaction'
    };
  },
  computed: {
    currency() {
      return (this.subscriptions && this.subscriptions?.currencySymbol) || '';
    }
  },
  watch: {
    currentlySelectedOrgId: function() {
      this.pageNumber = 1;
      this.pageSize = 20;
      this.sortOrder = 'DESC';
      this.getTransactions();
    }
  },
  methods: {
    addPaymentMethod(e) {
      e.preventDefault();
    },
    goBack() {
      this.$router.go(-1);
    },
    async sortBy(tableSortData) {
      this.sortOrder = tableSortData.sortOrder;
      this.getTransactions();
    },
    async getTransactions(searchParams) {
      this.rowsData = [];
      this.loading = true;

      try {
        const searchObj = searchParams
          ? searchParams
          : {
              page: this.pageNumber,
              pageSize: this.pageSize,
              order: this.sortOrder
            };

        const response = await BillingService.transactions(
          searchObj,
          this.axiosSource.token
        );
        const transactions = this.parseResponse(response);
        if (transactions) {
          this.totalRecords = transactions[0].totalResults;
          this.rowsData = transactions[0].transactions || [];
          this.$router.replace({ path: 'payments', query: searchObj });
        }
      } catch (err) {
        // Error message visible only for the case when request is not cancelled by UI using axios cancel token
        if (err?.message !== this.errorMessage) {
          this.snackbar('error', err);
        }
      }
      this.loading = false;
    },
    updatePageSize(pageSize) {
      this.pageSize = pageSize;
      this.pageNumber = 1;
      this.getTransactions();
    },
    editPaymentMethodSetting() {},
    setPage(pageNumber) {
      this.pageNumber = pageNumber;
      this.getTransactions();
    },
    initLoad() {
      this.pageNumber = !this.isEmpty(this.$route.query)
        ? parseInt(this.$route.query.page)
        : 1;
      this.pageSize = !this.isEmpty(this.$route.query)
        ? parseInt(this.$route.query.pageSize)
        : // eslint-disable-next-line
          20;
      // eslint-disable-next-line
      this.columns[3].sortable = false;

      this.columns[this.columns.length - 1].sortable = false;
    }
  },
  mounted() {
    this.getTransactions(
      !this.isEmpty(this.$route.query) ? this.$route.query : null
    );
    this.initLoad();
  },
  beforeDestroy() {
    // To cancel network call explicitly when user switch route before network call completes
    this.axiosSource.cancel(this.errorMessage);
  }
};
</script>
<style scoped>
#transaction__id {
  text-transform: capitalize;
}
</style>
